import React from 'react';
import Css from './Tile.scss';
import { Col, Row } from 'reactstrap';

const Tile = props => {
  let ContentText = [];

  //seperates paragraphs for the 'Why Visit' section Text Box
  props.content.split('\n').forEach(function(cur, ind) {
    ContentText.push(<p key={ind}>{cur}</p>);
  });

  return (
    <Row className={'mt-5 mb-5 pt-3'}>
      <Col xs={12}>
        <div
          className={
            'lakes-medium font-xl text-center mb-4 d-block d-md-none ' +
            Css.header
          }
        >
          {props.title}
        </div>
      </Col>
      {props.index % 2 === 0 ? (
        <React.Fragment>
          <Col md={6} className={Css.box}>
            <div
              className={
                Css['box-content'] +
                ' background-red color-white align-items-center scrollable custom-scroll ' +
                (props.index < 3 ? 'd-flex' : '')
              }
            >
              <div className={'py-3'}>
                <div
                  className={
                    'font-lg text-right mb-3 d-none d-md-block lakes-demibold'
                  }
                >
                  {props.title}
                </div>
                <div
                  className={'font-sm text-right'}
                  dangerouslySetInnerHTML={{ __html: props.content }}
                />
              </div>
            </div>
          </Col>
          <Col
            md={6}
            className={'d-flex align-items-center ' + Css['right-baner']}
          >
            <img src={props.image} alt={'Item 1'} />
          </Col>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Col
            md={6}
            className={'d-flex align-items-center ' + Css['left-baner']}
          >
            <img src={props.image} alt={'Item 1'} className={'mx-auto'} />
          </Col>
          <Col md={6} className={Css['left-box']}>
            <div
              className={
                Css['left-box-content'] +
                ' background-red color-white align-items-center scrollable custom-scroll ' +
                (props.index < 4 ? 'd-flex' : '')
              }
            >
              <div className={'py-3'}>
                <div
                  className={
                    'font-lg text-left mb-3 d-none d-md-block lakes-demibold'
                  }
                >
                  {props.title}
                </div>
                <div
                  className={'font-sm'}
                  dangerouslySetInnerHTML={{ __html: props.content }}
                />
              </div>
            </div>
          </Col>
        </React.Fragment>
      )}
    </Row>
  );
};

export default Tile;



// WEBPACK FOOTER //
// ./src/components/ExclusiveExperience/Tile/Tile.js